import * as sanitizeHtml from 'sanitize-html';
import { QuestionAssurance } from './useRenouvellementApi';

export const sanitizeLibelleAssurance = (
    listeQuestionUnsanitized: QuestionAssurance[]
): QuestionAssurance[] => {
    return listeQuestionUnsanitized.map(function (
        questionAssuranceUnsanitized: QuestionAssurance
    ) {
        const questionAssuranceSanitized: QuestionAssurance = {
            question: '',
            reponse: '',
            puces: [],
            titreModale: null,
            lienModale: null
        };

        questionAssuranceSanitized.question = sanitizeHtml(
            questionAssuranceUnsanitized.question,
            { allowedTags: [], allowedAttributes: {} }
        );

        questionAssuranceSanitized.reponse = sanitizeHtml(
            questionAssuranceUnsanitized.reponse,
            { allowedTags: [], allowedAttributes: {} }
        );

        if (questionAssuranceUnsanitized.puces) {
            questionAssuranceSanitized.puces =
                questionAssuranceUnsanitized.puces.map(function (
                    puceUnsanitized: string
                ) {
                    return sanitizeHtml(puceUnsanitized, {
                        allowedTags: [],
                        allowedAttributes: {}
                    });
                });
        }

        questionAssuranceSanitized.titreModale =
            questionAssuranceUnsanitized.titreModale;

        questionAssuranceSanitized.lienModale =
            questionAssuranceUnsanitized.lienModale;

        return questionAssuranceSanitized;
    });
};
